/*
 * Copyright (c) Dito Technologies
 */

import React from "react";

const StaffSelectPageOverlayError: React.FC = () => {

    return (
        <div>
            <p>Page Error</p>
        </div>
    )
}

export default StaffSelectPageOverlayError;